import { Card, Col, Empty, Row, Statistic } from "antd";
import { useEffect, useState } from "react";

import request from "@/api";
import { MyTaskAction } from "./MyTaskAction";

export interface MyTaskOtherStat {
    key: string;
    label: string;
    count: number;
    permissions?: readonly string[];
}

interface MyTaskOtherStatsProps {
    loadStats?: () => Promise<MyTaskOtherStat[]>;
}

const numberValue = (value: unknown) => Number(value || 0);

/** 复用 Vue 其他运营待办的六个统计接口。 */
export async function loadMyTaskOtherStats(): Promise<MyTaskOtherStat[]> {
    const [institution, help, features, message, corpus, funding] = await Promise.all([
        request.service.get("/admin/mytask/statisc/institution-apply"),
        request.service.get("/admin/mytask/statisc/help-center"),
        request.service.get("/admin/mytask/statisc/features-feedback"),
        request.service.get("/admin/mytask/statisc/message-feedback"),
        request.service.get("/admin/mytask/statisc/corpus-unmark"),
        request.service.get("/admin/mytask/statisc/funding-clues")
    ]);
    return [
        {
            key: "institution",
            label: "机构认证审核待审核",
            count: numberValue(institution.data?.reviewedCount),
            permissions: ["ROLE_ORG_REVIEW"]
        },
        {
            key: "message",
            label: "留言反馈待回复",
            count: numberValue(message.data?.unreturnedCount),
            permissions: ["ROLE_SS_FEEDBACK_W"]
        },
        {
            key: "features",
            label: "功能反馈待处理",
            count: numberValue(features.data?.waitHandle),
            permissions: ["ROLE_FUNCTION_W"]
        },
        {
            key: "help",
            label: "帮助中心待上架",
            count: numberValue(help.data?.unlistedCount),
            permissions: ["ROLE_SS_HELP_W"]
        },
        {
            key: "corpus",
            label: "AI语料库待标记",
            count: numberValue(corpus.data?.unMarkCount),
            permissions: ["ROLE_ASSISTANTS_CORPUS_W"]
        },
        {
            key: "funding",
            label: "资金线索待处理",
            count: numberValue(funding.data?.toBeProcessed),
            permissions: ["ROLE_FUNDS_W"]
        }
    ];
}

/** 其他运营待办统计卡片，沿用 Vue 的六类数量和状态文案。 */
export function MyTaskOtherStats({ loadStats = loadMyTaskOtherStats }: MyTaskOtherStatsProps) {
    const [stats, setStats] = useState<MyTaskOtherStat[]>([]);

    useEffect(() => {
        let disposed = false;
        void loadStats().then(result => {
            if (!disposed) setStats(result);
        });
        return () => {
            disposed = true;
        };
    }, [loadStats]);

    return (
        <Card title="其他">
            {stats.length ? (
                <Row gutter={[16, 16]}>
                    {stats.map(stat => (
                        <Col key={stat.key} xs={12} sm={8} md={6}>
                            <MyTaskAction stat={stat}>
                                <Statistic title={stat.label} value={stat.count} />
                            </MyTaskAction>
                        </Col>
                    ))}
                </Row>
            ) : (
                <Empty description="暂无数据" />
            )}
        </Card>
    );
}
